import React, { useState } from 'react';
import { CommonModal } from 'wsm-common-modal';
import { useLabels } from 'wsm-common-data';
import BadgeContent from './BadgeContent';
import { badgePropTypes, badgeDefaultProps } from '../types/badgeProps';
import {
	CARFAX_LINK_ATTRIBUTE,
	useCarfaxLeadSubmitted
} from '../utils/carfaxLead';

const BadgeWrapper = (props) => {
	const { badgeClasses = [], disclaimer = '', dataAttributes = {} } = props;

	const labels = useLabels();
	const [isOpenModal, setOpenModal] = useState(false);
	const hasSubmittedCarfaxLead = useCarfaxLeadSubmitted();

	const toggleOpenModal = () => {
		setOpenModal((previous) => !previous);
	};

	// WIS cannot see cookies, so it always gates; restore the report link once submitted.
	const carfaxReportLink = dataAttributes[CARFAX_LINK_ATTRIBUTE];
	const shouldRestoreCarfaxLink =
		hasSubmittedCarfaxLead && !!carfaxReportLink;

	const resolvedBadgeClasses = shouldRestoreCarfaxLink
		? badgeClasses.filter((badgeClass) => badgeClass !== 'dialog')
		: badgeClasses;

	const badgeContentProps = shouldRestoreCarfaxLink
		? {
				...props,
				href: carfaxReportLink,
				badgeClasses: resolvedBadgeClasses,
				dataAttributes: {}
		  }
		: props;

	const listItemClassName = `${resolvedBadgeClasses.join(
		' '
	)} vehicle-card-badge badge`;

	return (
		<>
			<li className={listItemClassName}>
				<BadgeContent
					{...badgeContentProps}
					toggleOpenModal={toggleOpenModal}
				/>
			</li>
			<CommonModal
				title={labels.get('DISCLAIMER_OPTION')}
				isOpen={isOpenModal}
				onClose={toggleOpenModal}
				key="common-modal"
			>
				{/* eslint-disable-next-line react/no-danger */}
				<div dangerouslySetInnerHTML={{ __html: disclaimer }} />
			</CommonModal>
		</>
	);
};

BadgeWrapper.propTypes = badgePropTypes;

BadgeWrapper.defaultProps = badgeDefaultProps;

export default BadgeWrapper;
